export const publicGetMethodService = async (api) => {
    try {
        // Omit credentials: public hosts (S3) often use ACAO * which browsers reject with credentials.
        let fetcher = await fetch(api ,{
            method: "GET",
            credentials: "omit",
            headers: {
                "Accept": "application/json",
            },
        });
        let res = await fetcher.json();
        if(fetcher.status === 200){
            return res;
        }else{
            return false;
        };
    } 
    catch (error) {
        if(error?.message === "Failed to fetch"){
            console.log(error);
        }
    }
}

export const getMethodService = async (api) => {
    try{
        let fetcher = await fetch(api ,{
            method: "GET",
            credentials: "include",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest",
            },
        });
        let res = await fetcher.json();
        if(fetcher.status === 500){
            return res?.message || res?.errors || "Something Wrong!";
        };
        if(fetcher.status === 429){
            return "429";
        };
        if(fetcher.status === 400){
            return res?.message || res?.errors || "Something Wrong!";
        };
        if(fetcher.status === 401 || fetcher.status === 403){
            return "Unauthenticated";
        };
        if(fetcher.status === 404){
            return res?.message || res?.errors || "Something Wrong!";
        };
        if(fetcher.status === 200){
            if(res){
                if(res.status === "success" || res.status || res.success){
                    return res;
                }
            };
        };
    }
    catch(err){
        return err.message;
    }
    
};

export const postMethodService = async (api,data) => {
    try{
        let fetcher = await fetch(api ,{
            method: "POST",
            credentials: "include",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest",
            },
            body: JSON.stringify(data),
        });
        let res = await fetcher.json();
        if(fetcher.status === 500){
            return res?.message || res?.errors || "Something Wrong!";
        };
        if(fetcher.status === 429){
            return res?.message || res?.errors || "Something Wrong!";
        };
        if(fetcher.status === 400){
            return res?.message || res?.errors || "Something Wrong!";
        };
        if(fetcher.status === 401){
            return "Unauthenticated";
        };
        if(fetcher.status === 404){
            return res?.message || res?.errors || "Something Wrong!";
        };
        if(fetcher.status === 200){
            if(res){
                if(res.status === "success" || res.status || res.success){
                    return res;
                }
            };
        };
    }
    catch(err){
        return err.message;
    }
};

export const putMethodService = async (api,data) => {
    try{
        let fetcher = await fetch(api ,{
            method: "PUT",
            credentials: "include",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest",
            },
            body: JSON.stringify(data),
        });
        let res = await fetcher.json();
        if(fetcher.status === 500){
            return res?.message || res?.errors || "Something Wrong!";
        };
        if(fetcher.status === 429){
            return res?.message || res?.errors || "Something Wrong!";
        };
        if(fetcher.status === 400){
            return res?.message || res?.errors || "Something Wrong!";
        };
        if(fetcher.status === 401){
            return "Unauthenticated";
        };
        if(fetcher.status === 404){
            return res?.message || res?.errors || "Something Wrong!";
        };
        if(fetcher.status === 200){
            if(res){
                if(res.status === "success" || res.status || res.success){
                    return res;
                }
            };
        };
    }
    catch(err){
        return err.message;
    };
};

export const deleteMethodService = async (api) => {
    try{
        let fetcher = await fetch(api ,{
            method: "DELETE",
            credentials: "include",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest",
            },
        });
        let res = await fetcher.json();
        if(fetcher.status === 500){
            return res?.message || res?.errors || "Something Wrong!";
        };
        if(fetcher.status === 429){
            return res?.message || res?.errors || "Something Wrong!";
        };
        if(fetcher.status === 400){
            return res?.message || res?.errors || "Something Wrong!";
        };
        if(fetcher.status === 401){
            return "Unauthenticated";
        };
        if(fetcher.status === 404){
            return res?.message || res?.errors || "Something Wrong!";
        };
        if(fetcher.status === 200){
            if(res){
                if(res.status === "success" || res.status || res.success){
                    return res;
                }
            };
        };
    }
    catch(err){
        return err.message;
    }
    
};

export const postMethodFormDataService = async (api,data) => {
    try{
        let fetcher = await fetch(api ,{
            method: "POST",
            credentials: "include",
            headers: {
                "Accept": "application/json",
                "X-Requested-With": "XMLHttpRequest",
            },
            body: data,
        });
        let res = await fetcher.json();
        if(fetcher.status === 500){
            return res?.message || res?.errors || "Something Wrong!";
        };
        if(fetcher.status === 429){
            return res?.message || res?.errors || "Something Wrong!";
        };
        if(fetcher.status === 400){
            return res?.message || res?.errors || "Something Wrong!";
        };
        if(fetcher.status === 401){
            return "Unauthenticated";
        };
        if(fetcher.status === 404){
            return res?.message || res?.errors || "Something Wrong!";
        };
        if(fetcher.status === 200){
            if(res){
                if(res.status === "success" || res.status || res.success){
                    return res;
                }
            };
        };
    }
    catch(err){
        return err.message;
    }
};

export const putMethodFormDataService = async (api,data) => {
    try{
        let fetcher = await fetch(api ,{
            method: "PUT",
            credentials: "include",
            headers: {
                "Accept": "application/json",
                "X-Requested-With": "XMLHttpRequest",
            },
            body: data,
        });
        let res = await fetcher.json();
        if(fetcher.status === 500){
            return res?.message || res?.errors || "Something Wrong!";
        };
        if(fetcher.status === 429){
            return res?.message || res?.errors || "Something Wrong!";
        };
        if(fetcher.status === 400){
            return res?.message || res?.errors || "Something Wrong!";
        };
        if(fetcher.status === 401){
            return "Unauthenticated";
        };
        if(fetcher.status === 404){
            return res?.message || res?.errors || "Something Wrong!";
        };
        if(fetcher.status === 200){
            if(res){
                if(res.status === "success" || res.status || res.success){
                    return res;
                }
            };
        };
    }
    catch(err){
        return err.message;
    }
};
